import Backbone from 'backbone';

const PlannedMetricCollection = Backbone.Collection.extend({
    model: Backbone.Model.extend({

        /*
         * TODO: 'id' is unwinded type for some profile/goal. We should omit it.
         * But it breaks in basemodel in nested obj.toJSON()
         */
    }),

    parse (response) {
        return _.map(response, (metric) => {
            metric = _.pick(metric, 'type', 'profile_id', 'goal_id', 'custom_metric_id', 'plan', 'fact');

            if (metric.goal_id) {
                metric.id = 'goal_{0}_{1}'.format(metric.goal_id, metric.type);
            } else if (metric.profile_id) {
                metric.id = 'profile_{0}_{1}'.format(metric.profile_id, metric.type);
            } else if (metric.custom_metric_id) {
                metric.id = 'custom_metric_{0}'.format(metric.custom_metric_id);
            } else {
                metric.id = metric.type;
            }

            return metric;
        });
    }
});

export default PlannedMetricCollection;
